import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledIconSwitch = styled.div<{
  $firstIcon?: boolean;
  $lastIcon: boolean;
  $disabled: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  cursor: ${({ $disabled }) => ($disabled ? "auto" : "pointer")};
  width: fit-content;
  height: fit-content;
  border: 1px solid ${theme.colors.grey_6};
  padding: 0 2px;
  height: 30px;
  border-radius: ${theme.variables.border_radius_1};

  & > div {
    border-radius: ${({ $firstIcon, $lastIcon }) =>
      $firstIcon ? "8px 0 0 8px" : $lastIcon ? "0 8px 8px 0" : "0"};
  }
`;

export const StyledIconSwitchItem = styled.div<{
  $isString: boolean;
  $isActive: boolean;
  $disabled: boolean;
}>`
  display: flex;
  padding: ${({ $isString }) => ($isString ? "3px 15px" : "3px 8px")};
  width: 100%;
  white-space: nowrap;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  z-index: 1;
  & span {
    transition: color 300ms ease-in;
  }
`;

export const StyledSwitchBookmark = styled.div<{
  $allowTransitions?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100%);
  background-color: ${theme.colors.purple_2};
  border-radius: 15px;
  transition: ${({ $allowTransitions }) =>
    $allowTransitions ? "all 300ms cubic-bezier(0.4, 0, 0.2, 1)" : "none"};
  z-index: 0;
`;
